const PromptOptions = {
  NOTICE_ONLY: 'notice_only',
  REQUIRE_CONSENT: 'require_consent',
  CONSENT_BY_DEFAULT: 'consent_by_default',
} as const;

export default PromptOptions;
